import { render, staticRenderFns } from "./ClockSourcePanel.vue?vue&type=template&id=23759f65&"
import script from "./ClockSourcePanel.vue?vue&type=script&lang=js&"
export * from "./ClockSourcePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports